import type { ScheduleModalNotification } from '../../types'

export type ScheduleModalNotify = (
  notification: ScheduleModalNotification,
) => void

export const createScheduleModalNotifier = (onNotify?: ScheduleModalNotify) => {
  return {
    create: (notification: ScheduleModalNotification) => {
      onNotify?.(notification)
    },
  }
}
